import React from 'react';
import type { FC } from 'react';

import styled from '@emotion/styled';

import { Box, Text, mq } from '@clutter/clean';

import MOVER_WITH_COUCH_SMALL from '@images/illustrations/mover_with_couch_small.svg';
import MOVER_WITH_SIXTEEN_FOOT_TRUCK_SMALL from '@images/illustrations/mover_with_sixteen_foot_truck_small.svg';
import ONLINE_QUOTE from '@images/illustrations/online_quote.svg';
import SELF_STORAGE_UNIT from '@images/illustrations/self_storage_unit.svg';

import { Section } from './section';

const ITEMS = [
  {
    title: 'We Pick Up',
    content: (
      <>
        <strong>No Lifting!</strong> We come to your place, expertly pack your
        belongings, and move them into storage. You won’t need to reserve a
        truck or go to a facility.
      </>
    ),
    icon: MOVER_WITH_COUCH_SMALL,
  },
  {
    title: 'We Store',
    content: (
      <>
        Your belongings are kept secure in{' '}
        <strong>temperature-controlled storage facilities</strong>. Every item
        is carefully handled and protected, ensuring it stays in perfect
        condition.
      </>
    ),
    icon: SELF_STORAGE_UNIT,
  },
  {
    title: 'You Manage',
    content: (
      <>
        Easily keep track of stored belongings with{' '}
        <strong>Clutter’s digital inventory</strong>. You can view your items
        online, so you always know what is in storage and can request them
        whenever needed.
      </>
    ),
    icon: ONLINE_QUOTE,
  },
  {
    title: 'We Deliver',
    content: (
      <>
        Whenever you need something back, just order a return, and Clutter will
        get it to your doorstep. No storage trips. No hassle.
      </>
    ),
    icon: MOVER_WITH_SIXTEEN_FOOT_TRUCK_SMALL,
  },
];

const Title = styled(Text.Title)`
  text-align: center;
`;

const Body = styled(Text.Body)`
  text-align: center;
`;

const Grid = styled.div`
  display: grid;
  gap: 32px;

  ${mq({
    gridTemplateColumns: ['1fr', '1fr 1fr', null, '1fr 1fr 1fr 1fr'],
  })}
`;

export const SectionHowClutterWorks: FC = () => (
  <Section padding="0 0 80px">
    <Box.Flex flexDirection="column" alignItems="center" gap="32px">
      <Title size="large" tag="h2">
        How Clutter Works
      </Title>
      <Grid>
        {ITEMS.map((item, index) => (
          <Box.Flex
            key={index}
            flexDirection="column"
            alignItems="center"
            gap="32px"
          >
            <img
              loading="lazy"
              alt=""
              style={{ height: '96px', width: 'auto' }}
              src={item.icon}
            />
            <Title size="extraSmall">{item.title}</Title>
            <Body>{item.content}</Body>
          </Box.Flex>
        ))}
      </Grid>
    </Box.Flex>
  </Section>
);
